import API from "../../API";
import { StringUtils } from "../../util";

const PAGE_SIZE_FOR_PACKAGES = 500;

const CACHE_KEY = "FIRMWARE_PACKAGES";

export default async () => {
  const packages = sessionStorage.getItem(CACHE_KEY);

  if (packages) return JSON.parse(packages);

  const res = await API.firmwarePackages.list({ page_size: PAGE_SIZE_FOR_PACKAGES });
  const ret = res.map((f) => ({
    ...f,
    sc: f?.firmware.find(
      (item) => item.binary_type === "application" && item.component_type === "SystemController",
    ),
    md: f?.firmware.find(
      (item) => item.binary_type === "application" && item.component_type === "MotorController",
    ),
    bms: f?.firmware.find(
      (item) => item.binary_type === "application" && item.component_type === "Battery",
    ),
    ...(f.url ? { id: StringUtils.uuidFromUrl(f.url) } : {}),
  }));

  sessionStorage.setItem(CACHE_KEY, JSON.stringify(ret));

  return ret;
};
